import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../theme/constants';
import { FlexContainer } from '@emarketer/componentlibrary';

export const CollectionsContainer = styled(FlexContainer)`
  margin-top: 24px;
  clear: both;
  margin-bottom: 15vh;
  position: relative;
  border-radius: 8px;
  flex-direction: column !important;
  justify-content: space-between;
  align-items: stretch;

  @media only screen and (min-width: 1200px) {
    max-width: 1170px;
    margin: 24px auto 15vh auto;
    flex-direction: row !important;
    border: 1px solid ${COLOR.LIGHTGREY};
  }

  @media only screen and (min-width: 1340px) {
    max-width: 1300px;
  }

  @media (max-width: 1200px) {
    margin-bottom: 40px;
  }
`;

export const CollectionsContainerLeft = styled.div`
  @media only screen and (min-width: 1200px) {
    margin-left: 0;
    align-self: flex-start;
    border-right: 1px solid ${COLOR.LIGHTGREY};
  }

  @media (max-width: 1200px) {
    width: 100%;
  }
`;

export const CollectionsContainerLeftContainer = styled.div`
  position: relative;
`;

export const CollectionsPickerContainer = styled.div`
  display: block;

  @media only screen and (min-width: 1200px) {
    width: 350px;
  }

  @media only screen and (min-width: 1340px) {
    width: 400px;
  }
`;

export const BecomeAClientContainer = styled.div`
  display: none;
  margin-top: 32px;
  margin-bottom: 24px;
  width: 100%;

  @media only screen and (min-width: 1200px) {
    display: flex;
  }

  @media only screen and (min-width: 1340px) {
    display: flex;
  }
`;

export const BecomeAClientMobileContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 32px;
`;

export const CollectionsContainerRight = styled.div`
  min-height: 500px;
  padding: 24px 40px;
  flex-grow: 1;

  @media only screen and (min-width: 1200px) {
    align-self: flex-start;
  }

  @media only screen and (max-width: 1340px) {
    padding: 8px 24px;
  }

  @media only screen and (max-width: 1200px) {
    padding: 0px 24px;
  }
`;

export const CollectionsContainerClear = styled.div`
  clear: both;
`;
